'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector read only field
 *
 * @class
 */

class InspectorSpinner extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div class="editor__inspector__item__label"><%- title %></div>
				<div class="editor__inspector__item__loader">
					<div class="throbber__bounce1"></div>
                    <div class="throbber__bounce2"></div>
                    <div class="throbber__bounce3"></div>
				</div>
			</div>
		`;

		super.render();
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
	}
}
module.exports = InspectorSpinner;